import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

// Bridges Turbo fetch failures (form submissions, turbo-frame lazy-loads) to
// native, which surfaces the connection-error view. Drive visit failures are
// handled on the native side via SessionDelegate/NavigatorDelegate — filtered
// out here by target tag to avoid double-firing.
export class BridgeConnectionErrorController extends BridgeComponent {
    static component = "connectionError"

    connect() {
        super.connect()
        if (!this.bridgeElement.enabled) return
        document.addEventListener("turbo:fetch-request-error", this.#handleError)
    }

    disconnect() {
        document.removeEventListener("turbo:fetch-request-error", this.#handleError)
        super.disconnect()
    }

    #handleError = (event) => {
        const tag = event.target?.tagName?.toLowerCase()
        if (tag !== "form" && tag !== "turbo-frame") return
        this.send("failed", {})
    }
}
